import { client } from "../client";
import { Paginated, PaginatedFilter } from "../types/axios.types";
import { Command } from "../types/command.types";
import { Patient, PatientStats } from "../types/patient.types";

export const fetchPatient = async (id: number | string | undefined) => {
    if (id == undefined) {
        return null
    }
    const response = await client.get<Patient>(`patients/${id}/`);
    return response.data
};


export const fetchPatients = async (page?: number, size?: number, search?: string, filters?: PaginatedFilter, sortBy?: string[]) => {
    const params = new URLSearchParams();
    // Pagination
    params.append('page', page ? page.toString() : '1')
    params.append('size', size ? size.toString() : '25')
    // Search
    if (search) {
        params.append('search', search)
    }
    // Sort
    if (sortBy) {
        sortBy.forEach(key => params.append('sort', key))
    }
    // Filters
    if (filters) {
        Object.keys(filters).forEach((key: string) => {
            // Blacklist some keys
            if (["page", "size", "search", "sort"].includes(key) || filters[key] === '') {
                return
            }
            params.append(key, Array.isArray(filters[key]) ? filters[key].join(',') : filters[key]);
        })
    }
    // Query
    const response = await client.get<Paginated<Patient[]>>(`patients/`, {
        params
    });
    return response.data
};

export const fetchPatientStats = async (id: number | string | undefined) => {
    if (id == undefined) {
        return null
    }
    const response = await client.get<PatientStats>(`patients/${id}/stats`);
    return response.data
};

export const fetchPatientCommands = async (id: number | string | undefined, page?: number, size?: number, search?: string, filters?: PaginatedFilter, sortBy?: string[]) => {
    if (id == undefined) {
        return null
    }
    const params = new URLSearchParams();
    // Pagination
    params.append('page', page ? page.toString() : '1')
    params.append('size', size ? size.toString() : '25')
    // Search
    if (search) {
        params.append('search', search)
    }
    // Sort
    if (sortBy) {
        sortBy.forEach(key => params.append('sort', key))
    }
    // Filters
    if (filters) {
        Object.keys(filters).forEach((key: string) => {
            // Blacklist some keys
            if (["page", "size", "search", "sort"].includes(key) || filters[key] === '') {
                return
            }
            params.append(key, Array.isArray(filters[key]) ? filters[key].join(',') : filters[key]);
        })
    }
    // Query
    const response = await client.get<Paginated<Command[]>>(`patients/${id}/commands`, {
        params
    });
    return response.data
};